module.exports = __webpack_public_path__ + "static/img/preview-06.1a23d95b.webp";